function uuid(): string {
  return crypto.randomUUID();
}

export const tmp = {
  machine: () => `tmp_machine_${uuid()}` as const,
  node: () => `tmp_node_${uuid()}` as const,
  edge: () => `tmp_edge_${uuid()}` as const,
  param: () => `tmp_param_${uuid()}` as const,
  sensor: () => `tmp_sensor_link_${uuid()}` as const,
  compat: () => `tmp_compat_${uuid()}` as const,
};

export const TMP_PREFIX_RE = /^tmp_(machine|node|edge|param|sensor_link|compat)_[0-9a-fA-F-]{36}$/;

export function isTmpId(value: unknown): value is string {
  return typeof value === "string" && TMP_PREFIX_RE.test(value);
}
